export default "__VITE_ASSET__BlZxGk2P__"